import {
  SET_BLOGS_STATUS,
  SET_BLOGS_CATEGORY
} from '@/store/mutation-types'

const changeSearchBlogsStatus = ({commit, dispatch}, payload) => {
  commit(SET_BLOGS_STATUS, payload)
}
const changeSearchBlogsCategory = ({commit, dispatch}, payload) => {
  commit(SET_BLOGS_CATEGORY, payload)
}


export default {
  changeSearchBlogsStatus,
  changeSearchBlogsCategory
}



// WEBPACK FOOTER //
// ./src/components/blogs/store/actions.js